import { render } from "./nav-bar.html?vue&type=template&id=63440802&scoped=true"
import script from "./nav-bar.js?vue&type=script&lang=js"
export * from "./nav-bar.js?vue&type=script&lang=js"

import "./nav-bar.scss?vue&type=style&index=0&id=63440802&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63440802"

export default script